import format from "date-fns/fp/format";

export const formatEndTimeFormValue = (d: Date) => {
  return format("yyyy-MM-dd'T'hh:mm")(d);
};
